import PlusIcon from "app/components/Icons/PlusIcon";
import CustomTooltip from "app/components/Tooltip";
import { BoardViewType } from "app/types";
import clsx from "clsx";
import React, { forwardRef } from "react";

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  viewType: BoardViewType;
  minTableWidth: number;
}

const triggerClass =
  "bg-white rounded-[6px] hover:bg-gray-200 border border-gray-100 flex justify-center items-center outline-none hover:bg-gray-400 rounded data-[state=open]:border-secondary data-[state=open]:outline-secondary data-[state=open]:border-[1px] outline-[0px] focus:outline-[0px]";

const RenderTrigger = forwardRef<HTMLButtonElement, Props>(
  ({ viewType, minTableWidth, ...props }, ref) => {
    if (viewType === BoardViewType.KANBAN) {
      return (
        <button
          ref={ref}
          type="button"
          {...props}
          className={clsx(triggerClass, "p-[13px]")}
        >
          <CustomTooltip
            text="Add group"
            contentClassName="p-[10px]"
            position="bottom"
          >
            <PlusIcon size={20} color="#79808A" />
          </CustomTooltip>
        </button>
      );
    }

    if (viewType === BoardViewType.LIST) {
      return (
        <div
          className="flex flex-row items-center gap-[4px] mt-[5px] mb-[15px] h-[30px] relative"
          style={{ minWidth: minTableWidth }}
        >
          <div
            className="sticky left-[62px] bg-gray-400 group-hover:bg-gray-200 flex flex-row items-center gap-[4px] px-[4px]"
            style={{ minWidth: 747 }}
          >
            <button
              ref={ref}
              type="button"
              {...props}
              className={clsx(triggerClass, "h-[30px] px-[10px]")}
            >
              <PlusIcon size={16} color="#79808A" />
              <span className="text-sm text-secondary">
                Add hidden group(s)
              </span>
            </button>
          </div>
          <div className="flex-1 bg-gray-400 group-hover:bg-gray-200"/>
        </div>
      );
    }

    return null;
  },
);

RenderTrigger.displayName = "RenderTrigger";

export default RenderTrigger;
